import createUpdateFilesEvents from '/src/lib/custom/js/createupdatefilejson.js';

const saveAsEvents = (function () {
  let browseFileData = null;
  const eventListeners = []; // Tracks all event listeners
  let browseSelectedFile = null;
  let browseSelectedPath = null;
  let saveAsCallback;
  let vendor = null;
  let folderUUID = null;

  const addListener = (selector, event, delegatedSelector, handler) => {
    if (delegatedSelector) {
      $(selector).on(event, delegatedSelector, handler); // Handle delegated events
    } else {
      $(selector).on(event, handler); // Handle direct binding
    }
    eventListeners.push({ selector, event, delegatedSelector, handler });
  };


  const bindEvents = () => {

    $('#browse-submitRename').prop('disabled', true);

    $('#browse-newFileName').on('input', function () {

      const newName = $(this).val().trim();
      const errorMessage = $('#rename-filename-error');

      // Check if the new name is different from the original name
      const isSameAsOriginal = newName === browseSelectedFile;

      // Check if filename already exists in browseFileData
      const isNameTaken = browseFileData && browseFileData.some(file => {
        return file.fileName === newName;
      });

      // Check if filename contains a dot
      const hasDot = newName.includes('.');

      // Validation logic with appropriate error messages
      if (isSameAsOriginal || newName === '') {
        errorMessage.text(getI18n('enter_unique_filename')).show();
        $('#browse-submitRename').prop('disabled', true);
      } else if (isNameTaken) {
        errorMessage.text(getI18n('filename_exists')).show();
        $('#browse-submitRename').prop('disabled', true);
      } else if (hasDot) {
        errorMessage.text(getI18n('filename_no_dot')).show();
        $('#browse-submitRename').prop('disabled', true);
      } else {
        // If all checks pass, hide the error message and enable the submit button
        errorMessage.hide();
        $('#browse-submitRename').prop('disabled', false);
      }
    });


    addListener('#browse-closeRenameDialog, #browse-cancelRename', 'click', () => {
      hideModalBackDrop();
      unload();
      $('#browse-renameDialog').hide();
    });



    addListener('#browse-submitRename', 'click', function (e) {
      e.stopImmediatePropagation();
      e.stopPropagation();

      const newName = $('#browse-newFileName').val();
      if (newName && browseSelectedFile) {
          if (typeof saveAsCallback === 'function') {
            saveAsCallback(newName, hideAndUnload);
        } else {
            console.error('saveAsCallback is not a function');
        }

      } else {
        Swal.fire({
          title: getI18n('alert'),
          text: getI18n('invalid_filename_or_selection'),
          icon: "warning",
        });
        hideAndUnload
      }
    });
  };

  const hideAndUnload = () =>{
    hideModalBackDrop();
    $('#browse-renameDialog').hide();
    unload();

  }



  const unbindEvents = () => {
    // Unbind modal-related events
    $('#browse-submitRename').off('click');
    $('#browse-closeRenameDialog, #browse-cancelRename').off('click');
    $('#browse-renameBtn').off('click');
    $('#browse-closeModal').off('click');
  };


  const init = (initFolderUUID, initVendor, fileName, doSaveAsCloudCallback) => {
    try {
      // Assign to module-level variables
      showModalBackDrop();
      vendor = initVendor;
      folderUUID = initFolderUUID;
      browseSelectedFile = fileName;
      saveAsCallback = doSaveAsCloudCallback;
      $('#renameFileDialogHeading').text(getI18n('save_as'));
      $('#browse-newFileName').val(browseSelectedFile);
      $('#browse-renameDialog').show();
      loadFiles(fileName);
      bindEvents();
    } catch (error) {
      hideModalBackDrop();
      console.error('Error during initialization:', error);
    }
  };

  const loadFiles = (fileName) => {
    const storageKey = 'browse_files'
    // Check if data exists in localStorage
    const cachedData = localStorage.getItem(storageKey);
    if (cachedData) {
      const parsedData = JSON.parse(cachedData);
      browseFileData = parsedData;

      const matchedFile = parsedData.find(file => file.fileName === fileName);
      if (matchedFile) {
        browseSelectedPath = matchedFile.filePath;
      }
    }
  };


  const unload = () => {
    // Unbind all event listeners
    if (eventListeners) {
      eventListeners.forEach(({ selector, event, handler }) => {
        try {
          $(selector).off(event, handler);
        } catch (error) {
          console.error(`Error while removing event listener for Selector: ${selector}, Event: ${event}`, error);
        }
      });
      eventListeners.length = 0; // Clear the array after removing all listeners
    }

    unbindEvents();
    // Reset data
    browseFileData = null;
    browseSelectedFile = null;
    browseSelectedPath = null;
    saveAsCallback = null;
  };



  return { init, unload };
})();

export default saveAsEvents;
